import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import './AddExpensePage.css'; // We'll create this CSS file next

const AddExpensePage = () => {
    // State for the form fields
    const [expenseType, setExpenseType] = useState('');
    const [amount, setAmount] = useState('');
    const [expenseDate, setExpenseDate] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    // useNavigate hook to redirect the user after submission
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic validation
        if (!expenseType || !amount || !expenseDate) {
            alert("Please fill out all fields.");
            return;
        }
        if (isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
            alert("Please enter a valid, positive amount.");
            return;
        }

        setIsSubmitting(true);
        try {
            // Get a reference to the 'expenses' collection.
            // Firestore creates this collection automatically if it doesn't exist.
            const expensesCollectionRef = collection(db, "expenses");

            // Add a new document with the form data.
            await addDoc(expensesCollectionRef, {
                expenseType: expenseType,
                amount: parseFloat(amount),
                expenseDate: expenseDate,
                createdAt: serverTimestamp(),
                createdBy: "Admin" // You can replace this later with an authenticated user
            });

            alert("General expense added successfully!");
            // Navigate the user back to the main expenses list
            navigate('/expenses'); 
        } catch (error) {
            console.error("Error adding expense document: ", error);
            alert("Failed to add expense. Please check the console.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="form-container-expense">
            <h1>Add General Expense</h1>
            <form onSubmit={handleSubmit} className="expense-form">
                <div className="form-group">
                    <label htmlFor="expenseType">Expense Type</label>
                    <input 
                        type="text" 
                        id="expenseType" 
                        placeholder="e.g., Office Rent, Marketing"
                        value={expenseType} 
                        onChange={(e) => setExpenseType(e.target.value)} 
                        required 
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="amount">Amount (INR)</label>
                    <input 
                        type="number" 
                        id="amount" 
                        placeholder="e.g., 10000"
                        value={amount} 
                        onChange={(e) => setAmount(e.target.value)} 
                        required 
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="expenseDate">Date of Expense</label>
                    <input 
                        type="date" 
                        id="expenseDate" 
                        value={expenseDate} 
                        onChange={(e) => setExpenseDate(e.target.value)} 
                        required 
                    />
                </div>
                <button type="submit" className="submit-button" disabled={isSubmitting}>
                    {isSubmitting ? 'Saving...' : 'Save Expense'}
                </button>
            </form>
        </div>
    );
};

export default AddExpensePage;